"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledUnstyledButton = void 0;
var _UnstyledButton = require("./UnstyledButton");
// TODO: in v9, move styled() from UnstyledButton.jsx to here
var StyledUnstyledButton = _UnstyledButton.UnstyledButton;
exports.StyledUnstyledButton = StyledUnstyledButton;